// extracted by mini-css-extract-plugin
export default {"wrapper":"Cards_wrapper--ToB","slider":"Cards_slider--Ord","title":"Cards_title--z2o"};